import {ComponentsConfigs} from '@gongxigames/framework/core/types/systemComponentsTypes';
import {KoalaBigWinModule} from '@gongxigames/framework/slotV2/modules-koala/bigwin/KoalaBigWinModule';

export * from '@gongxigames/framework/slotV2/modules-koala/bigwin/RichTextBigWin';

export const koalaComponentsConfig: ComponentsConfigs = {
    modules: [
        KoalaBigWinModule
    ],
    views: [
        // KoalaBigWinView
    ]
};